// extracted by mini-css-extract-plugin
export default {"header":"wbA8R__header","main":"IwXgt__main","downloadWrapper":"JJGgU__downloadWrapper","downloadIcon":"JR8oi__downloadIcon","downloadLink":"Nwr5T__downloadLink"};